import { cdnRegex, ImageServiceType } from '../constants';
/**
 * This function returns the image service type.
 *
 * @param url - The image url.
 * @returns - Return type of image service.
 */
const getImageServiceType = (url) => {
    if (url.match(cdnRegex.liquidpixel)) {
        return ImageServiceType.LIQUID_PIXELS;
    }
    if (url.match(cdnRegex.akamai)) {
        return ImageServiceType.AKAMAI;
    }
    return ImageServiceType.UNKNOWN;
};
export default getImageServiceType;
//# sourceMappingURL=getImageServiceType.js.map